import { Wallet } from '../api/models';
import find from 'lodash/find';

export const includeManagedWallet = (wallets?: Wallet[] | null): boolean => {
  return !!find(wallets, { managed: true });
};
